import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import avatar from 'assets/img/team/avatar.png';
import Avatar from 'components/common/Avatar';
import paths from 'routes/paths';
import ChangePassword from 'components/pages/user/settings/ChangePassword';

const ProfileDropdown = () => {
  const navigate = useNavigate();

  const [isUserAdmin, setIsUserAdmin] = useState(false);

  useEffect(() => {
    const storedRoles = JSON.parse(sessionStorage.getItem('roles'));
    if (storedRoles) {
      setIsUserAdmin(storedRoles.includes('ADMIN'));
    } else {
      setIsUserAdmin(false);
    }
  }, []);

  const logout = event => {
    sessionStorage.removeItem('token');
    navigate('/authentication/simple/login');
  };

  const ChangePassword = event => {
    navigate('/authentication/simple/change-password');
  };

  return (
    <Dropdown navbar={true} as="li">
      <Dropdown.Toggle
        bsPrefix="toggle"
        as={Link}
        to="#!"
        className="pe-0 ps-2 nav-link"
      >
        <Avatar src={avatar} />
      </Dropdown.Toggle>

      <Dropdown.Menu className="dropdown-caret dropdown-menu-card  dropdown-menu-end">
        <div className="bg-white rounded-2 py-2 dark__bg-1000">
          {/* <Dropdown.Item as={Link} to={paths.userProfile}>
            Profile &amp; account
          </Dropdown.Item>
          <Dropdown.Item href="#!">Feedback</Dropdown.Item>
          <Dropdown.Divider />
          <Dropdown.Item as={Link} to={paths.userSettings}>
            Settings
          </Dropdown.Item> */}
          <Dropdown.Item as={Link} to="/client-list" hidden={!isUserAdmin}>
            Cadastro de Clientes
          </Dropdown.Item>
          <Dropdown.Item as={Link} to="/change-password">
            Alterar Senha
          </Dropdown.Item>
          <Dropdown.Item as={Link} onClick={logout}>
            Sair
          </Dropdown.Item>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default ProfileDropdown;
